import { useEffect } from "react";

export function useFilterAutoScroll(
  selected: string,
  containerRef: React.RefObject<HTMLDivElement>,
  enabled: boolean = true
) {
  useEffect(() => {
    if (!enabled) return;
    if (!selected || !containerRef.current) return;

    const container = containerRef.current;

    requestAnimationFrame(() => {
      const element = container.querySelector(
        '[data-selected="true"]'
      ) as HTMLElement | null;

      if (!element) return;

      const offsetTop = element.offsetTop - container.offsetTop;

      container.scrollTo({
        top: offsetTop - container.clientHeight / 2,
        behavior: "smooth",
      });
    });
  }, [selected, containerRef, enabled]);
}